import React, { useState, useEffect } from 'react';
import TableComponent from '../../../SharedComponents/Table';
import BasicButton from '../../../SharedComponents/BasicButton/BasicButton';
import { licensorQuickViewTableConfig, buildLicensorSummaryRows } from './licensorQuickViewConfig';
import { quickViewSortList, updateTableSortConfigObject } from '../../../../Common/TableHelper';
import './LicensorQuickView.scss';

const LicensorQuickView = ({
    licensors = [],
    isMainTitle = false,
    selectedIndex = null,
    isEditingLocked = false,
    onSelect,
    onAdd,
}) => {
    const [sortBy, setSortBy] = useState(null);
    const [sortCount, setSortCount] = useState(0);
    const [isSortByAsc, setIsSortByAsc] = useState(true);
    const [config, setConfig] = useState(() => JSON.parse(JSON.stringify(licensorQuickViewTableConfig)));
    const [sortedRows, setSortedRows] = useState([]);

    useEffect(() => {
        setSortedRows(buildLicensorSummaryRows(licensors, isMainTitle));
    }, [licensors, isMainTitle]);

    const handleSort = (column) => {
        const heading = licensorQuickViewTableConfig.headings.find(h => h.headingLabel === column);
        const newCount = column === sortBy ? sortCount + 1 : 0;
        const asc = newCount % 2 === 0;
        setSortBy(column);
        setSortCount(newCount);
        setIsSortByAsc(asc);
        setConfig(updateTableSortConfigObject(config, asc, sortBy, column));
        setSortedRows(prev => quickViewSortList(
            heading?.sortType || 'Name',
            heading?.sortNode || column,
            [...prev],
            asc,
            { separator: heading?.sortSeparator, order: heading?.sortOrder },
        ));
    };

    const handleRowClick = (_event, dataItem) => {
        if (isEditingLocked) {
            return;
        }
        onSelect(dataItem.index);
    };

    return (
        <div className="licensor-quick-view">
            <div className="licensor-quick-view-header">
                <div className="licensor-quick-view-title-group">
                    <span className="licensor-quick-view-title">Licensors</span>
                    <span className="licensor-quick-view-count">{sortedRows.length}</span>
                </div>
                {onAdd && (
                    <BasicButton
                        variant="contained"
                        type="inline"
                        color="primary"
                        text="Add a Licensor"
                        onClick={onAdd}
                    />
                )}
            </div>
            <div className={`licensor-quick-view-table${isEditingLocked ? ' is-editing-locked' : ''}`}>
                <TableComponent
                    list={sortedRows}
                    config={config}
                    className="licensorQuickView"
                    tableMode="light"
                    stickyHeader={false}
                    initialRightsFlag={!isEditingLocked}
                    initialRightsRowClick={handleRowClick}
                    selectedIndex={selectedIndex}
                    sortCallback={handleSort}
                />
            </div>
            {isEditingLocked ? (
                <div className="licensor-quick-view-editing-note">
                    Save or cancel the current licensor edit before selecting another licensor.
                </div>
            ) : (
                <div className="licensor-quick-view-hint">
                    Select a row to open full licensor details.
                </div>
            )}
        </div>
    );
};

export default LicensorQuickView;
